import { toast } from 'react-toastify';

// Shared options so every toast looks and behaves consistently.
const base = {
  position: 'top-right',
  autoClose: 2000
};

export const notify = {
  success: (message) => toast.success(message, base),

  // Errors linger a little longer — they matter more.
  error: (message) => toast.error(message || 'Something went wrong', { ...base, autoClose: 2000 }),

  info: (message) => toast.info(message, base),

  // For an action in progress that resolves later (e.g. a slow request).
  // Returns an id you can update with notify.resolve / notify.reject.
  loading: (message) => toast.loading(message, { position: 'top-right' }),

  resolve: (id, message) =>
    toast.update(id, { render: message, type: 'success', isLoading: false, ...base }),

  reject: (id, message) =>
    toast.update(id, {
      render: message || 'Something went wrong',
      type: 'error',
      isLoading: false,
      ...base,
      autoClose: 2000
    })
};
